module.exports = __webpack_public_path__ + "static/media/Server.c21ecd85.svg";